export default {
  routerBase: {
    'install': '设置',
    'homepage': '首页',
    'statistics': '统计',
    'history': '历史',
    'starttest': '开始测量',
    'data': '数据',
    'myfamily': '我的家人',
    'family': '家人',
    'setting': '设置',
    'personal': '个人',
    'consultation': '咨询',
    'measurement': '测量结果',
    'improveprofile': '完善个人资料',
    'changephone': '更换手机号',
    'information': '资讯',
    'health report': '健康报告',
    'healthwarning': '健康预警',
    'healthadvice': '健康建议',
    'pressure': '血压',
    'sugar': '血糖',
    'heartrate': '心率',
    'oxygen': '血氧',
    'step': '步数',
    'hrv': 'HRV心脏指数',
    'apnea': '呼吸暂停次数',
    'description': '商品详情',
    'submitorder': '提交订单',
    'orderlist': '订单列表',
    'personaldetails': '个人信息',
    'mdi': '手动输入',
    'record': '登录',
    'help': '帮助中心',
    'downloadAPP': '下载盖德健康APP',
    'associatedmobile': '关联手机号',
    'privacypolicy': '《用户服务协议及隐私政策条款》',
    'analysisreport ': '分析报告',
    'electrocardiogram': '查看心电图',
    'directionforuse ': '使用说明',
    'privacypolicy ': '隐私政策',
    'addfamily': '添加家人',
    'bindaccount': '账号绑定',
    'familyAdd': '新添家人',
    'register': '注册',
    'putcode': '发送验证码'

  }
}
